import React from 'react';

/**
 * Skeleton placeholder cards shown during initial data load.
 * Mobile-first; mimics the entries list layout.
 */
const EntriesSkeleton = ({ count = 4 }) => (
  <div className="space-y-3 p-4">
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="rounded-2xl border border-slate-200/60 bg-white p-4 animate-pulse"
        style={{ animationDelay: `${i * 80}ms` }}
      >
        <div className="flex items-start justify-between gap-2 mb-3">
          <div className="h-3.5 bg-slate-200 rounded w-1/2" />
          <div className="h-5 bg-slate-200 rounded-md w-20" />
        </div>
        <div className="h-3 bg-slate-100 rounded w-3/4 mb-2" />
        <div className="h-3 bg-slate-100 rounded w-2/3 mb-3" />
        <div className="h-3.5 bg-slate-200 rounded w-1/3 mb-2" />
        <div className="flex items-center justify-between">
          <div className="h-3 bg-slate-100 rounded w-1/3" />
          <div className="h-3.5 bg-slate-200 rounded w-1/4" />
        </div>
      </div>
    ))}
  </div>
);

export default EntriesSkeleton;
